import styled from 'styled-components'
import { Form, Input, Typography, Modal, Button, Image } from 'antd'
import { IconFont } from '@/components'
import { UserOutlined } from '@ant-design/icons'
import { CommonProps } from '.'
import { useEffect, useState } from 'react'
import { useVerify, useEmail, useRepeat } from './util'
import { FormInstance } from 'antd/es/form'
import { t } from '@/i18n'

interface SendModal {
  visibel: boolean
  type: 0 | 1
}

const { useForm } = Form
interface ForgetPwdProps extends CommonProps {}
export const ForgetPwd = (props: ForgetPwdProps) => {
  const formRef = React.createRef<FormInstance>()
  const [form] = useForm()
  let search = window.location.protocol
  const { setLoginStatus } = props
  const [sendModal, setSendModal] = useState<SendModal>({
    visibel: false,
    type: 0,
  })
  const [verify] = useVerify()
  const [email] = useEmail()
  let [base, setBase] = useState({ base64: '', verify_token: '' })
  let [emailItem, setEmailItem] = useState('')
  const verification = () => {
    verify({ verify_type: 'reset_email' })
      .then(res => {
        setBase((base = res.data))
      })
      .catch(err => {})
  }
  useEffect(() => {
    verification()
  }, [])

  const toLogin = () => setLoginStatus('direct-login')
  const modalConfirmHandler = () => {
    if (sendModal.type === 0) {
      setSendModal({ visibel: false, type: 0 })
    } else {
      toLogin()
    }
  }
  const loginHandler = (values: any) => {
    formRef.current!.setFieldsValue({ verify: '' })
    email({
      ...values,
      id_token: base.verify_token,
      url: `${window.location.protocol}//${window.location.host}/account/lost/password`,
    })
      .then(res => {
        setSendModal({ visibel: true, type: 1 })
      })
      .catch(err => {
        verification()
        // setSendModal({ visibel: true, type: 0 })
      })
  }
  return (
    <Direct>
      <RetrieveText>{t('找回密码')}</RetrieveText>
      <RetrieveDescribe>{t('我们将会发送一封包含重置密码链接的邮件到您的邮箱')}</RetrieveDescribe>
      <Form form={form} ref={formRef} onFinish={loginHandler}>
        <Form.Item
          name="email"
          rules={[
            { type: 'email', message: t('请输入正确的邮箱') },
            { required: true, message: t('请输入邮箱/用户名') },
          ]}
        >
          <Input
            placeholder={t('请输入邮箱')}
            prefix={<UserOutlined style={{ color: '#333333' }} />}
            onChange={e => {
              setEmailItem((emailItem = e.target.value))
            }}
          />
        </Form.Item>
        <div style={{ display: 'flex' }}>
          <Form.Item
            name={'verify'}
            rules={[{ required: true, message: t('请输入验证码') }]}
            style={{ width: '70%', marginRight: '10px' }}
          >
            <Input
              placeholder={t('请输入验证码')}
              prefix={
                <IconFont style={{ color: '#333333', fontSize: '14px' }} type={'icon-yanzhengma'} />
              }
            />
          </Form.Item>
          <div style={{ width: '30%', borderRadius: '4px', overflow: 'hidden', height: '32px' }}>
            <Image
              height={'32px'}
              src={`data:image/png;base64,${base?.base64}`}
              preview={false}
              onClick={() => verification()}
            />
          </div>
        </div>
        <SendBtn>
          <Button block className="send" onClick={form.submit}>
            {t('发送')}
          </Button>
        </SendBtn>
        <ReturnLogin>
          <Typography.Link className="retrieve" onClick={toLogin}>
            {t('返回登录')}
          </Typography.Link>
        </ReturnLogin>
      </Form>
      <Modal
        centered
        closable={false}
        footer={null}
        visible={sendModal.visibel}
        maskClosable={false}
      >
        <DetermineBtnContainer>
          {/* {sendModal.type === 0 && <SendError />} */}
          {sendModal.type === 1 && <SendSuccess email={emailItem} />}
          <SendConfirmBtn
            className="sendConfirm"
            onClick={() => {
              if (sendModal.type === 0) {
                formRef.current!.setFieldsValue({ verify: '' })
              }
              modalConfirmHandler()
            }}
          >
            {t('确认')}
          </SendConfirmBtn>
        </DetermineBtnContainer>
      </Modal>
    </Direct>
  )
}

const SendSuccess = props => {
  const { email } = props
  let [repeat] = useRepeat()
  const [countdown, setCountdown] = useState(60)

  useEffect(() => {
    let countdownInterval

    if (countdown > 0) {
      countdownInterval = setInterval(() => {
        setCountdown(prevCount => prevCount - 1)
      }, 1000)
    }

    return () => {
      clearInterval(countdownInterval)
    }
  }, [countdown])
  return (
    <ResultContainer>
      <IconFont type={'icon-chenggong2'} className="icon" />
      <div className="result">{t('发送成功')}</div>
      <div className="text">
        {t('没有收到邮件?')}
        {countdown > 0 ? (
          <span className="countdown">{countdown}S</span>
        ) : (
          <Typography.Link
            onClick={() => {
              repeat({ email: email })
                .then(res => {
                  setCountdown(60)
                })
                .catch(err => {})
            }}
            className="resend"
          >
            {t('重新发送')}
          </Typography.Link>
        )}
      </div>
    </ResultContainer>
  )
}

// const SendError = () => (
//   <ResultContainer>
//     <IconFont type={'icon-cuowu1'} className="icon" />
//     <div className="result">发送失败</div>
//     <div className="text">此邮箱不存在</div>
//   </ResultContainer>
// )

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .icon {
    font-size: 54px;
  }
  .result {
    margin: 5px 0;
    margin-top: 10px;
    font-size: 24px;
  }
  .text {
    color: #666;
    margin: 10px 0;
  }
  .countdown {
    color: #999999;
    margin-left: 5px;
    font-size: 14px;
  }
  .resend {
    margin-left: 5px;
    cursor: pointer;
    color: #4238c9;
    &:hover {
      color: #2973ff;
    }
  }
`
const Direct = styled.div`
  .ant-input-affix-wrapper,
  .ant-input {
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
  }
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  .send {
    height: 38px;
    color: #fff;
    background: #4238c9;
    border: 1px solid #4238c9;
    &:hover {
      background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
      border: none;
    }
  }
`
const RetrieveText = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
  color: #666666;
`

const RetrieveDescribe = styled.div`
  height: 36px;
  color: #666666;
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.4;
`
const DetermineBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .sendConfirm {
    background: #4238c9;
    :hover {
      background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%);
    }
  }
`
export const ReturnLogin = styled.div`
  margin-top: 20px;
  text-align: center;
  .retrieve {
    color: #666666;
    font-size: 12px;
    &:hover {
      color: #807ddb;
    }
  }
`

const SendBtn = styled.div`
  color: #fff;
  background: #4238c9;
  border-radius: 6px;
  height: 38px;
  &:hover {
    background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
  }
`

const SendConfirmBtn = styled.button`
  color: #fff;
  border: 1px solid #4238c9;
  background: #4238c9;
  border-radius: 6px;
  padding: 0 15px;
  height: 32px;
  &::after {
    display: none;
  }
  &:hover {
    background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%) !important;
    cursor: pointer;
  }
`
